<div class="container" [style.gap]="selectedSettingTab ? '16px' : '32px'">
    <ng-container *ngIf="!selectedSettingTab">
        <div class="title">
            {{ 'ops-setting.tab.output-settings' | translate }}
        </div>
        <div class="tabs">
            <div *ngFor="let tab of TABS" class="tab" (click)="selectTab(tab)">
                <div>{{ tab | translate }}</div>
                <mat-icon class="icon" svgIcon="chevron-right" />
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="selectedSettingTab">
        <ng-container *ngIf="!selectedSetting; else digitalSetting">
            <div class="header-container">
                <div class="header" (click)="selectTab()">
                    <mat-icon class="icon chevron-left" svgIcon="chevron-right" />
                    <div>{{ selectedSettingTab | translate }}</div>
                </div>
                <div class="sub-header">
                    <ng-container *ngIf="selectedSettingTab == DO_TERMINALS">
                        {{ 'output-settings.DO-terminals.subtitle' | translate }}
                    </ng-container>
                    <ng-container *ngIf="selectedSettingTab == AO_TERMINALS">
                        {{ 'output-settings.AO-terminals.subtitle' | translate }}
                    </ng-container>
                </div>
            </div>

            <div class="slot-selector-container" [class.disabled]="!canEditVessel()">
                <div class="slot-selector-title">
                    {{ 'output-settings.slot-selector.title' | translate }}
                </div>
                <app-slot-selector
                    #slotSelector
                    [vesselSlots]="vesselSlots"
                    [selectedSlot]="selectedSlot"
                    [settingsType]="getSettingsType()"
                    (onSlotSelected)="handleSelectedSlot($event)"
                    [disabled]="!canEditVessel()"></app-slot-selector>
            </div>
        </ng-container>
        <ng-template #digitalSetting>
            <div class="header" (click)="handleSelectedDigitalSetting()">
                <mat-icon class="icon chevron-left" svgIcon="chevron-right" />
                <div *ngFor="let title of getSlotTileArray()">
                    {{ title }}
                </div>
            </div>
            <div class="sub-header">
                {{ 'output-settings.DO.header-subtitle' | translate }}
            </div>
        </ng-template>
    </ng-container>
</div>

<ng-container *ngIf="selectedSlot && !selectedSetting">
    <div class="container" style="margin-top: 12px">
        <ng-container *ngIf="selectedSettingTab == DO_TERMINALS">
            <app-digital-output-settings-table
                class="settings-table"
                [selectedSlot]="selectedSlot"
                [vessel]="vessel"
                (onSettingSelected)="handleSelectedDigitalSetting($event)"></app-digital-output-settings-table>
        </ng-container>
        <ng-container *ngIf="selectedSettingTab == AO_TERMINALS">
            <app-analog-output-settings-table
                class="settings-table"
                [selectedSlot]="selectedSlot"
                [channels]="channels"
                [vessel]="vessel"
                (onCancel)="handleCancel()"></app-analog-output-settings-table>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="selectedSetting">
    <ng-container *ngIf="showDigitalSettings; else addSettingButton">
        <div class="container" style="margin-top: 12px">
            <app-digital-output-setting
                class="settings-table"
                [setting]="selectedSetting"
                [selectedSlot]="selectedSlot"
                [vessel]="vessel"
                (onCancel)="handleCancelDO()"
                (onDelete)="handleDelete()"></app-digital-output-setting>
        </div>
    </ng-container>

    <ng-template #addSettingButton>
        <div class="add-setting-button" (click)="showDigitalSettings = true">
            {{ 'output-settings.DO.add-setting' | translate }}
        </div>
    </ng-template>
</ng-container>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
